.fdi-wc-sortable-items{
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;
  .fdi-wc-sortable-menu{
    width: 100%;
    margin-bottom: 10px;
    div{
      padding: 0 5px;
      cursor: pointer;
      display: inline-block;
      margin: 0 5px;
      &:hover{
        background: #ececec;
      }
    }
  }
  >li{
    border: solid 2px black;
    min-height: 50px;
    display: inline-block;
    margin: 0 5px 5px 0;
    background: #ccc;
    position: relative;
    &:hover > .itemMenu{
      display: block;
    }
    .itemMenu{
      background: white;
      border-bottom: 2px solid black;
      div{
        padding: 0 5px;
        cursor: pointer;
        display: inline-block;
        &:hover{
          background: #ececec;
        }
      }
    }
  }
  .innerItemContainer{
    padding: 5px;
    li{
      display: block;
      background: #f6f6f6;
      margin: 3px;
      padding-right: 10px;
    }
  }
}

.sortableGhost{
  background: yellow !important;
}
